import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum BankAccountsResolverErrorStatesEnum {
    GetLinkedAccountsFailed = ErrorStateScheduleEnum.BankAccountsResolverErrorStatesStartIndex,
    GetCryptoCurrenciesFailed
}
